export const NOTIFICATION = 'NOTIFICATION'
export const SHOW_NOTIFICATION_SUCCESS = 'SHOW_NOTIFICATION_SUCCESS'
export const SHOW_NOTIFICATION_ERROR = 'SHOW_NOTIFICATION_ERROR'
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'
